import { Component, Input, ViewChild } from '@angular/core';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { EnumPageDisplayModes, EnumPageEntitySources } from '@core/framework/sysenums.enum';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-previewdialog',
    templateUrl: './previewdialog.component.html',
    styleUrls: ['./previewdialog.component.scss']
})
export class PreviewDialogComponent extends BasePageComponent<BaseEntity, BaseState> {
    @Input() Url: string;

    constructor(A: ServiceBagService, public sanitizer: DomSanitizer) {
        super(A, 'PreviewDialogComponent', BaseEntity, BaseState, EnumPageDisplayModes.Dialog, EnumPageEntitySources.External);
    }

    get src() {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.Url)
    }
}
